module.exports = __webpack_public_path__ + "static/media/sound_off.9bb386d0.svg";